import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { useBlog } from '../components/BlogContext';
import { Helmet } from 'react-helmet-async';
import './BlogPost.css';

const BlogPost = () => {
  const { slug } = useParams();
  const { getBlogPostBySlug } = useBlog();
  const post = getBlogPostBySlug(slug);

  if (!post) {
    return (
      <>
      <Helmet defer={false}>
        <title>Blog Post Not Found - Quick Way Car Wash UAE</title>
        <meta name="description" content="The blog post you're looking for doesn't exist. Browse our latest car care tips and news from Quick Way in UAE." />
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <div className="blog-post-page">
        <div className="container">
          <div className="post-not-found">
            <h1>Blog Post Not Found</h1>
            <p>The blog post you're looking for doesn't exist or has been removed.</p>
            <Link to="/blog" className="back-to-blog">
              ← Back to Blog
            </Link>
          </div>
        </div>
      </div>
      </>
    );
  }

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <>
    <Helmet defer={false}>
      <title>{post.seoTitle || post.title} - Quick Way Car Wash UAE</title>
      <meta name="description" content={post.seoDescription || `${post.title} - Latest car care tips and news from Quick Way in UAE.`} />
      <meta name="robots" content="noindex, follow" />
    </Helmet>
    <div className="blog-post-page">
      <div className="container">
        <article className="blog-post">
          {post.featuredImage && (
            <div className="post-hero-image">
              <img
                src={post.featuredImage}
                alt={post.title}
                onError={(e) => {
                  e.target.src = '/logo.png'; // Fallback to logo if image fails
                }}
              />
            </div>
          )}

          <header className="post-header">
            <h1 className="post-title">{post.title}</h1>
            <div className="post-meta">
              <time dateTime={post.createdAt}>
                Published on {formatDate(post.createdAt)}
              </time>
              {post.updatedAt !== post.createdAt && (
                <span className="updated-date">
                  • Updated on {formatDate(post.updatedAt)}
                </span>
              )}
            </div>
          </header>

          <div
            className="post-content"
            dangerouslySetInnerHTML={{ __html: post.content }}
          />

          <footer className="post-footer">
            <div className="post-navigation">
              <Link to="/blog" className="back-to-blog">
                ← Back to Blog
              </Link>
            </div>

            <div className="post-share">
              <h4>Share this post:</h4>
              <div className="share-buttons">
                <a
                  href={`https://wa.me/?text=${encodeURIComponent(`${post.title} - ${window.location.href}`)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="share-button whatsapp"
                >
                  WhatsApp
                </a>
                <button
                  onClick={() => {
                    navigator.share?.({
                      title: post.title,
                      text: post.seoDescription || post.title,
                      url: window.location.href
                    }).catch(() => {
                      // Fallback: copy to clipboard
                      navigator.clipboard.writeText(window.location.href);
                      alert('Link copied to clipboard!');
                    });
                  }}
                  className="share-button share"
                >
                  Share
                </button>
              </div>
            </div>
          </footer>
        </article>

        {/* Related posts section could be added here */}
      </div>
    </div>
    </>
  );
};

export default BlogPost;
